import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { ILocationHistory } from '@obvious.tech/constellation'

export const LocationHistory = defineEntity('LocationHistory', {
  endpoint: 'geolocation/api/LocationHistory',
  schema: SNoop<ILocationHistory>(),
})
